import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { clearExamples, loadExamples } from 'redux/Examples/actions';
import { ssrHandler } from 'utils';

import ExamplesTemplate from './ExamplesTemplate';

const MOBILE_WIDTH = 580;

class Examples extends PureComponent {
  render() {
    return (
      <ExamplesTemplate
        examples={this.props.examples}
        buttonLabel={this.props.buttonLabel}
        isMobile={this.props.isMobile}
      />
    );
  }
}

Examples.propTypes = {
  examples: PropTypes.shape({
    results: PropTypes.arrayOf(PropTypes.object),
    isFetching: PropTypes.bool,
    fetchingErrors: PropTypes.object
  }),
  isMobile: PropTypes.bool
};

function getServiceName(pathname) {
  const [name] = pathname
    .split('/')
    .filter(Boolean)
    .slice(-2);

  return name;
}

const mapStateToProps = (state, props) => {
  const name = getServiceName(props.location.pathname);

  return {
    buttonLabel: promotion[name],
    examples: state.examples,
    isMobile: state.app.width < MOBILE_WIDTH
  };
};

function loadExamplesData(store, nextState, replace, callback) {
  const name = getServiceName(nextState.location.pathname);
  const actions = [loadExamples(name)];

  ssrHandler(store.dispatch, actions, callback);
}

function clearExamplesData(store, nextState) {
  store.dispatch(clearExamples());
}

const createRoute = (store, pathname) => ({
  path: `/promotion/${pathname}/examples/`,
  component: connect(mapStateToProps)(Examples),
  onEnter: loadExamplesData.bind(null, store),
  onLeave: clearExamplesData.bind(null, store)
});

const promotion = {
  memorandums: 'Скачать PDF',
  'annual-reports': 'Перейти',
  'presentations-and-reports': 'Скачать PDF',
  'sections-on-sites': 'Перейти'
};

export default store => Object.keys(promotion).map(createRoute.bind(null, store));



// WEBPACK FOOTER //
// ./src/components/Examples/index.js